// @ts-nocheck

import Link from 'next/link'
import Slider from 'react-slick'
import React, { useEffect, useState } from 'react'
import Frame1 from '../../../../../../public/assets/img/WomansCategory/s1.png'
import Frame2 from '../../../../../../public/assets/img/WomansCategory/s2.png'
import Frame3 from '../../../../../../public/assets/img/WomansCategory/s3.png'
import Frame4 from '../../../../../../public/assets/img/WomansCategory/s4.png'
import others from '../../../../../../public/assets/img/WomansCategory/others.png'
import aroww from '../../../../../../public/assets/img/WomansCategory/aroww.png'
import star from '../../../../../../public/assets/img/WomansCategory/star.png'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useAppDispatch } from 'src/store/store'
import AosAnimation from 'src/utils/AosAnimation'
import { useRouter } from 'next/router'
import { fetchModalData } from 'src/store/slices/manageModalSlice'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { fetchProductByCategory } from 'src/store/slices/fetchAllProduct'
import GET_ALL_PRODUCTS from 'src/graphql/queries/getAllProducts'
import client1 from 'src/utils/apolloClient'

export default function WomenTredingSection() {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const [page, setPage] = useState(1)
  const [dataLimite, setDataLimite] = useState(35)
  const [productData, setProductData] = useState([])
  const productByCategory = useSelector((state: any) => state?.productByCategory)
  const getAllState = useSelector((state: any) => state?.manageModalData?.data)
  const [allProductData, setAllProductData] = useState([])

  useEffect(() => {
    setPage(1)
    fetchProduct()
  }, [])

  const fetchProduct = async () => {
    const { data } = await client1.query({
      query: GET_ALL_PRODUCTS,
      variables: {
        categoryName: 'fashion-and-accessories',
        subCategoryName: router?.asPath?.includes('women') ? 'women' : 'men',
        childSubCategoryName: router?.query?.category ? router?.query?.category : '',
        isShopifyProduct: false,
        page: page,
        limit: dataLimite,
        order: 'like_count',
      },
      fetchPolicy: 'network-only',
    })
    setAllProductData(data?.getAllProducts?.data)
  }

  const Cards = [
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: Frame3,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: Frame3,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: Frame3,
      type: 'large',
      parent_fill: false,
      product: true,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
          product: true,
        },
        {
          img: Frame2,
          type: 'small',
          product: true,
        },
      ],
    },
  ]

  const settings: any = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 5.5,
    slidesToScroll: 3,
    lazyLoad: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          lazyLoad: true,
          pauseOnHover: true,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          lazyLoad: true,
          pauseOnHover: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          lazyLoad: true,
          pauseOnHover: true,
        },
      },
      {
        breakpoint: 968,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          lazyLoad: true,
          pauseOnHover: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          lazyLoad: true,
          pauseOnHover: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1,
          lazyLoad: true,
          pauseOnHover: true,
        },
      },
    ],
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  useEffect(() => {
    if (allProductData?.length > 0) {
      let i = 0
      const result: any = Cards.map((card: any, index) => {
        if (card.product) {
          card.product_data = allProductData[i]
          i++
        }
        if (card.child) {
          card.child = card.child.map((child, ind) => {
            if (child.product) {
              child.product_data = allProductData[i]
              i++
            }
            return child
          })
        }
        return card
      })
      setProductData(result)
    }
  }, [allProductData])

  const handleProductOpen = (product) => {
    router.push(`/product/${product.slug}`);
  }

  return productData?.length > 0 ? (
    <section className="section_4">
      <AosAnimation animationType="fade-up" duration={500} delay={150}>
        <div className="section_4_head">
          <h3>Now Trending</h3>
          <Link
            href={{
              pathname: `/fashion/women`,
              query: { type: 'trending' },
            }}
            scroll={false}
          >
            <a>See All</a>
          </Link>
        </div>
        <div className="section_4_heading">
          <h4>Now Trending</h4>
          <Link
            href={{
              pathname: `/fashion/women`,
              query: { type: 'trending' },
            }}
            scroll={false}
          >
            <div className="mobile_view_seeMore">
              <a>See More</a>
            </div>
          </Link>
        </div>
      </AosAnimation>
      <div className="trending_block">
        <div className="trending_block_row ">
          <Slider {...settings}>
            {productData?.map((prd, i) => {
              
              return (
                <React.Fragment key={i}>
                  {prd.parent_fill ? (
                    <AosAnimation animationType="fade-up" duration={1000} delay={50}>
                      <div className="card_col">
                        <div className="cardcover">
                          <div className="cart_height1">
                            <img src={prd?.child[0]?.product_data?.images[0]?.src} alt="card_top_img" />
                          </div>
                          <div className="card_bottom">
                            <div
                              className="WomeCardContent"
                              onClick={() => handleProductOpen(prd?.child[0]?.product_data)}
                            >
                              <h1>{prd?.child[0]?.product_data?.title}</h1>
                              <div className="WomenCardPrice">
                                <p>${prd?.child[0]?.product_data?.dis_price}</p>
                                <del>
                                  {prd?.child[0]?.product_data?.dis_listPrice ? '$' : ''}{' '}
                                  {prd?.child[0]?.product_data?.dis_listPrice}{' '}
                                </del>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cardcover">
                          <div className="cart_height2">
                            <img src={prd?.child[1]?.product_data?.images[0]?.src} alt="card_top_img" />
                          </div>
                          <div className="card_bottom">
                            <div className="WomeCardContent" onClick={() => handleProductOpen(prd?.child[1]?.product_data)}>
                              <h1>{prd?.child[1]?.product_data?.title}</h1>
                              <div className="WomenCardPrice">
                                <p>${prd?.child[1]?.product_data?.dis_price}</p>
                                <del>
                                  {prd?.child[1]?.product_data?.dis_listPrice ? '$' : ''}{' '}
                                  {prd?.child[1]?.product_data?.dis_listPrice}{' '}
                                </del>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AosAnimation>
                  ) : (
                    <>
                      <AosAnimation animationType="fade-up" duration={1500} delay={100}>
                        <div className="card_col">
                          <div className="cardcover">
                            <div className="cart_height3">
                              <img src={prd?.product_data?.images[0]?.src} alt="card_top_img" />
                            </div>
                            <div className="card_bottom">
                              <div className="WomeCardContent" onClick={() => handleProductOpen(prd?.product_data)}>
                                <h1>{prd?.product_data?.title}</h1>
                                <div className="WomenCardPrice">
                                  <p>${prd?.product_data?.dis_price}</p>
                                  <del>
                                    {prd?.product_data?.dis_listPrice ? '$' : ''}
                                    {prd?.product_data?.dis_listPrice}
                                  </del>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </AosAnimation>
                    </>
                  )}
                </React.Fragment>
              )
            })}
          </Slider>
        </div>
      </div>
    </section>
  ) : (
    <></>
  )
}

{
  /* <Slider {...settings}>
{productData?.map((prd, i) => {
  return (
    <React.Fragment key={i}>
      {prd.parent_fill ? (
        <AosAnimation animationType="fade-up" duration={1000} delay={50}>
          <div className="card_col">{i}
            <div className="cardcover">
              <div className="card_top">
                <img src={prd?.child[0]?.product_data?.images[0]?.src} alt="card_top_img" />
              </div>
              <div className="card_bottom">
                <div className="card_bottom_cover">
                  <h4>Plain And Check Shirts</h4>
                  <p className="amount">
                    <span className="price">$245</span>
                    <span className="orignal_price"> $ 425.00 </span>
                    <span className="discount">40% OFF</span>
                  </p>
                  <p className="hike">
                    <span className="inter">
                      <img src={others.src} alt="hike" /> Interest
                    </span>
                    <span className="incris">
                      <img src={aroww.src} alt="incris" /> 200%
                    </span>
                  </p>
                  <div className="rating">
                    <span className="rating_point">4.8</span>
                    <div className="stars">
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                    </div>
                    <span className="num">(437)</span>
                  </div>
                  <button className="buy_btn" onClick={handleRedirect}>
                    Buy
                  </button>
                </div>
              </div>
            </div>
            <div className="cardcover">
              <div className="card_top">
                <img src={prd?.child[1]?.product_data?.images[0]?.src} alt="card_top_img" />
              </div>
              <div className="card_bottom">
                <div className="card_bottom_cover">
                  <h4>Plain And Check Shirts</h4>
                  <p className="amount">
                    <span className="price">$245</span>
                    <span className="orignal_price"> $ 425.00 </span>
                    <span className="discount">40% OFF</span>
                  </p>
                  <p className="hike">
                    <span className="inter">
                      <img src={others.src} alt="hike" /> Interest
                    </span>
                    <span className="incris">
                      <img src={aroww.src} alt="incris" /> 200%
                    </span>
                  </p>
                  <div className="rating">
                    <span className="rating_point">4.8</span>
                    <div className="stars">
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                      <img src={star.src} alt="star" />
                    </div>
                    <span className="num">(437)</span>
                  </div>
                  <button className="buy_btn" onClick={handleRedirect}>
                    Buy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </AosAnimation>
      ) : (
        <>
          <AosAnimation animationType="fade-up" duration={1500} delay={100}>
            <div className="card_col">
              <div className="cardcover">
                <div className="card_top">
                  <img src={prd?.product_data?.images[0]?.src} alt="card_top_img" />
                </div>
                <div className="card_bottom">
                  <div className="card_bottom_cover">
                    <h4>Plain And Check Shirts</h4>
                    <p className="amount">
                      <span className="price">$245</span>
                      <span className="orignal_price"> $ 425.00 </span>
                      <span className="discount">40% OFF</span>
                    </p>
                    <p className="hike">
                      <span className="inter">
                        <img src={others.src} alt="hike" /> Interest
                      </span>
                      <span className="incris">
                        <img src={aroww.src} alt="incris" /> 200%
                      </span>
                    </p>
                    <div className="rating">
                      <span className="rating_point">4.8</span>
                      <div className="stars">
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                        <img src={star.src} alt="star" />
                      </div>
                      <span className="num">(437)</span>
                    </div>
                    <button className="buy_btn" onClick={handleRedirect}>
                      Buy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </AosAnimation>
        </>
      )}
    </React.Fragment>
  )
})}
</Slider> */
}
